module.exports = __webpack_public_path__ + "img/23.708a8949.png";